import './formLogin.css';

const FormLogin = ({ onSubmit, legenda, children }) => {
    return (
        <div className='container-form-template-login'>
            <form className='form-template-login' onSubmit={onSubmit}>
                <fieldset>
                    <legend>{legenda}</legend>
                    {children}
                </fieldset>
            </form>
        </div>
    );
};

export default FormLogin;